:host {
  --line-height: inherit;
  --padding: var(--size-space-0);
  --margin: var(--size-space-0);
  --max: auto;
  color: inherit;
  display: var(--display, inline-block);
}

:host(.text-block) {
  display: var(--display, block);
}

:host(.display0) {
  @apply text-display0;
}

:host(.display1) {
  @apply text-display1;
}

:host(.display2) {
  @apply text-display2;
}

:host(.heading1) {
  @apply text-headline1;
}

:host(.heading2) {
  @apply text-headline2;
}

:host(.heading3) {
  @apply text-headline3;
}

:host(.body0) {
  @apply text-body0;
}

:host(.body1) {
  @apply text-body1;
}

:host(.body2) {
  @apply text-body2;
}

:host(.body3) {
  @apply text-body3;
}

:host(.body4) {
  @apply text-body4;
}

:host(.button) {
  @apply text-button1;
}

:host(.button2) {
  @apply text-button2;
}

:host(.callout1) {
  @apply text-callout1;
}

:host(.callout2) {
  @apply text-callout2;
}

:host(.caption) {
  @apply text-caption;
}

:host(.tag) {
  @apply text-tag;
}

.text {
  margin: var(--margin);
  padding: var(--padding);
  display: var(--display);
  color: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: var(--line-height);
}

.ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  /* For this to work, block is required */
  display: block;
  line-height: 1.1;
  max-width: var(--max);
}
/* Priority */

.secondary {
  @apply alpha-secondary;
}

.inactive {
  @apply alpha-inactive;
}

.tertiary {
  @apply alpha-tertiary;
}
/** expressive  */
.expressive {
  @apply bg-gradient-expressive bg-clip-text text-transparent decoration-clone;
  box-decoration-break: clone;
}
